module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-timetal__container"
  }, [_c('div', {
    staticClass: "d-guides"
  }, [_c('StilGuides', {
    attrs: {
      "video-id": '5Id4TeuHMvI',
      "textForLink": "Guide: Se videoguide for kompetenceindberetning i Docendo"
    }
  }), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "d-filters"
  }, [_c('div', {
    staticClass: "d-filters__filter",
    class: {
      'd-filters__filter--active': _vm.activeUserFilter === 0
    },
    on: {
      "click": function($event) {
        _vm.activeUserFilter = 0
      }
    }
  }, [_vm._v("Indberettes\n      "), _c('div', {
    staticClass: "d-pill"
  }, [_vm._v(_vm._s(_vm.filledUsers.length))])]), _vm._v(" "), _c('div', {
    staticClass: "d-filters__filter",
    class: {
      'd-filters__filter--active': _vm.activeUserFilter === 1
    },
    on: {
      "click": function($event) {
        _vm.activeUserFilter = 1
      }
    }
  }, [_vm._v("Indberettes ikke\n      "), _c('div', {
    staticClass: "d-pill"
  }, [_vm._v(_vm._s(_vm.unfilledUsers.length))])])]), _vm._v(" "), _c('table', {
    staticClass: "d-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "d-table__sorter d-table__name",
    class: {
      'd-table__sorter--active': _vm.sortProperty === 'name'
    },
    on: {
      "click": function($event) {
        return _vm.setSortProperty('name')
      }
    }
  }, [_vm._v("Navn "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "d-table__sorter",
    class: {
      'd-table__sorter--active': _vm.sortProperty === 'v_stil_stilling'
    },
    on: {
      "click": function($event) {
        return _vm.setSortProperty('v_stil_stilling')
      }
    }
  }, [_vm._v("Stilling "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', [_vm._v("CPR")]), _vm._v(" "), _c('th', [_vm._v("Kompetencer: (L: Linjefag, K: Tilsvarende kompetencer)")])])]), _vm._v(" "), _c('tbody', [(_vm.filteredUsersWithVProps.length < 1) ? _c('tr', [_vm._m(1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedUsers), function(user, userIdx) {
    return _c('tr', {
      key: user.id
    }, [_c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.v_stil_stilling),
        expression: "user.v_stil_stilling"
      }],
      staticClass: "timetal-select",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(user, "v_stil_stilling", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateUser(user, 'stil_stilling', $event.target.value)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "LA"
      }
    }, [_vm._v("Lærer")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "BH"
      }
    }, [_vm._v("Børnehaveklasseleder")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "PA"
      }
    }, [_vm._v("Pædagog")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "LE"
      }
    }, [_vm._v("Leder")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "AN"
      }
    }, [_vm._v("Andre med undervisningsopgaver")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "KO"
      }
    }, [_vm._v("Konsulenter")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "undtaget"
      }
    }, [_vm._v("Ingen undervisningsopgaver (ikke indberet)")])])]), _vm._v(" "), _c('td', [_c('input', {
      staticStyle: {
        "width": "110px"
      },
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": user.v_ssn
      },
      on: {
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.updateUser(user, 'ssn', $event.target.value, true)
        },
        "blur": function($event) {
          return _vm.updateUser(user, 'ssn', $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "400px"
      },
      on: {
        "click": function($event) {
          _vm.theEditUserId = user.id
        }
      }
    }, [(user.v_isTheEditUser) ? _c('DSelect', {
      attrs: {
        "show": true,
        "items": _vm.standardSubjectsWithVProps,
        "itemsSelected": user.v_competencies,
        "placeholder": "Tilføj kompetence"
      },
      on: {
        "close": function($event) {
          _vm.theEditUserId = null
        },
        "update": function($event) {
          return _vm.updateSubjectOnUser($event, user)
        }
      }
    }) : _c('ul', {
      staticClass: "linjefag linjefag--not-empty",
      staticStyle: {
        "width": "400px"
      }
    }, [(user.v_competencies.length === 0) ? _c('li', {
      staticClass: "linjefag__add"
    }, [_vm._v("\n              Tilføj op til seks kompetencer\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((user.v_competencies), function(subject) {
      return _c('li', {
        staticClass: "d-pill"
      }, [_vm._v("\n              " + _vm._s(subject.name) + "\n            ")])
    })], 2)], 1)])])
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-explainer"
  }, [_c('a', {
    attrs: {
      "href": "https://statistik.uni-c.dk/linjefag/Dokumentation/Generelvejledning2025.pdf",
      "target": "_blank"
    }
  }, [_vm._v("\n        Link til STIL's egen vejledning")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Linjefag (L):")]), _vm._v(" At have undervisningskompetence i et fag betyder, at underviseren har haft det\n        pågældende fag som linjefag på læreruddannelsen eller som ekstra linjefag på et senere tidspunkt.")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Tilsvarende kompetence (K):")]), _vm._v(" At have kompetence svarende til undervisningskompetence betyder, at\n        underviseren for eksempel har en efteruddannelse, videreuddannelse, kompetencegivende uddannelse eller et\n        længerevarende kursusforløb, der vurderes at give kompetence svarende til undervisningskompetence.")]), _vm._v(" "), _c('p', [_vm._v("Skolens leder må foretage et skøn i denne forbindelse. En underviser kan samlet set maks. have\n        kompetencer (undervisningskompetence og tilsvarende\n        kompetence) i seks fag")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Ikke indberet person:")]), _vm._v(" Personale der ikke skal indberettes sættes til stillingen \"Ingen\n        undervisningsopgaver (ikke indberet)\"")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('p', {
    staticClass: "text-explainer"
  }, [_vm._v("Ingen skal ikke indberetes")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-100ca672!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/KompetenceIndberetning/KompetenceIndberetningLinjeFag.vue
// module id = 1474
// module chunks = 1